<template>
  <section v-editable="blok" :class="getComponentClass(blok, animationClass)">
    <div class="container">
      <div class="row">
        <div
          :class="blok.variation === 'article-text--left' ? 'col-md-6' : ''"
          class="col-12"
        >
          <h3 class="article-text__title">{{ blok.title }}</h3>
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="blok.content && blok.content[0]"
            class="article-text__content"
            v-html="blok.content[0].text.content"
          />
          <!-- eslint-enable -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ArticleText',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    animateWhenVisible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      animationClass: '',
      isAnimationActive: true,
    }
  },
  watch: {
    visible(visible) {
      if (visible && this.isAnimationActive) {
        this.animationClass =
          ' article-text--animate article-text--animate-done'
        this.isAnimationActive = false
      }
    },
  },
  mounted() {
    if (this.animateWhenVisible) {
      this.animationClass = ' article-text--animate'
    }
  },
  methods: {
    getComponentClass(blok, animationClass) {
      const space = blok.space ? `space--${blok.space}` : 'space--small'
      const base = 'theme-light article-text'
      return `${base} ${blok.variation} ${animationClass} ${space}`
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/scss/settings';

.article-text {
  &--animate {
    .article-text__title,
    .article-text__content {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.3s ease-out 0.2s;
    }
  }
  &--animate-done {
    .article-text__title,
    .article-text__content {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  &__title {
    @include font-size(36);
    @include font-family($font-family-headings-bold);

    margin-top: 0;
    margin-bottom: spacer(3);
  }

  &__content {
    @include font-family($font-family-text);
    p {
      margin: 0 0 10px 0;
    }

    ul {
      @include font-size(30, rem-v(28));

      padding: 0;
      margin-top: 50px;
      margin-bottom: 0;
    }

    li {
      padding-left: 30px;
      margin-left: 25px;
      margin-bottom: 25px;

      span,
      li {
        @include font-size(16);
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .article-text {
    &__title {
      margin-bottom: spacer(1);
    }

    &--single {
      .container {
        max-width: 800px;
      }
    }

    &--double {
      .article-text__content {
        column-count: 2;
        column-gap: 30px;
      }
    }

    &--triple {
      .article-text__content {
        column-count: 3;
        column-gap: 30px;
      }
    }
  }
}
</style>
